import { createSlice } from '@reduxjs/toolkit';

const classroomName = createSlice({
  name: 'classroomName',
  initialState: {
    classroomNamesObj: {},
  },
  reducers: {
    setClassroomName(state, action) {
      state.classroomNamesObj = action.payload;
    },
  },
});

export const { setClassroomName } = classroomName.actions;

export const getClassroomName = state => state.classroomName.classroomNamesObj;

export default classroomName.reducer;
